export const stripQuery = (url: string): URL | undefined => {
  try {
    const parsed = new URL(url, window.location.href)
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return undefined

    if (parsed.pathname === '/_next/image') {
      const inner = parsed.searchParams.get('url')
      if (inner) {
        return stripQuery(inner)
      }
    }

    parsed.search = ''
    parsed.hash = ''
    return parsed
  } catch {
    return undefined
  }
}
